export default __webpack_public_path__ + "static/media/q4.b3ccae68.svg";